"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import GailLoader from "@/components/shared/GailLoader";

const SignUpPage = () => {
    const router = useRouter();

    useEffect(() => {
        router.push("https://gail.lula.com");
    }, [router]);

    return <GailLoader />;
};

export default SignUpPage;
